import { render, staticRenderFns } from "./HealthNav.vue?vue&type=template&id=266d3f58&scoped=true"
import script from "./HealthNav.vue?vue&type=script&lang=js"
export * from "./HealthNav.vue?vue&type=script&lang=js"
import style0 from "./HealthNav.vue?vue&type=style&index=0&id=266d3f58&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266d3f58",
  null
  
)

export default component.exports